import { ActionsUnion, createAction } from '../_commons/actions.common';
import { QuestionnaireAnswer } from '../jobOffers/jobOffers.dto';
import { SubmitJobApplicationCommandResponse } from './jobOfferApplication.thunk';

export enum JobOfferApplicationActionTypes {
    SAVE_STATIC_QUESTIONS_ANSWERS = 'JOB_OFFER_APPLICATION_SAVE_STATIC_QUESTIONS_ANSWERS',
    SAVE_ADDITIONAL_ANSWERS = 'JOB_OFFER_APPLICATION_SAVE_ADDITIONAL_ANSWERS',

    SUBMIT_APPLICATION_STARTED = 'JOB_OFFER_APPLICATION_SUBMIT_APPLICATION_STARTED',
    SUBMIT_APPLICATION_FINISHED = 'JOB_OFFER_APPLICATION_SUBMIT_APPLICATION_FINISHED',
    SUBMIT_APPLICATION_FAILED = 'JOB_OFFER_APPLICATION_SUBMIT_APPLICATION_FAILED'
}

export const JobOfferApplicationActions = {
    saveStaticQuestionsAnswers: (
        firstName: string,
        lastName: string,
        prefix: string,
        phoneNumber: string,
        email: string
    ) =>
        createAction(JobOfferApplicationActionTypes.SAVE_STATIC_QUESTIONS_ANSWERS, {
            firstName,
            lastName,
            prefix,
            phoneNumber,
            email
        }),
    saveAdditionalAnswers: (additionalAnswers: QuestionnaireAnswer[]) =>
        createAction(JobOfferApplicationActionTypes.SAVE_ADDITIONAL_ANSWERS, { additionalAnswers }),

    submitApplicationStarted: () => createAction(JobOfferApplicationActionTypes.SUBMIT_APPLICATION_STARTED),
    submitApplicationFinished: () => createAction(JobOfferApplicationActionTypes.SUBMIT_APPLICATION_FINISHED),
    submitApplicationFailed: (error: string | SubmitJobApplicationCommandResponse) =>
        createAction(JobOfferApplicationActionTypes.SUBMIT_APPLICATION_FAILED, { error })
};

export type JobOfferApplicationAction = ActionsUnion<typeof JobOfferApplicationActions>;
